import * as React from 'react';

import {motion} from 'framer-motion';

import {AccountsCircleIcon} from 'shells/icon/svg/accounts-circle-icon';
import {ContactsCircleIcon} from 'shells/icon/svg/contacts-circle-icon';
import {LeadsCircleIcon} from 'shells/icon/svg/leads-circle-icon';
import type {PageChangeDirection} from 'shells/onboarding-modal/types';
import {Title} from 'shells/typography/title';

import {GrowingDottedLine} from '../graphics-pieces/growing-dotted-line';

import styles from './graphic-leads.module.css';

const spring = {
    type: 'spring',
    damping: 100,
    stiffness: 50,
} as const;

type Props = {
    direction: PageChangeDirection;
};

export class GraphicLeads extends React.PureComponent<Props> {
    render() {
        const shouldAnimate = this.props.direction === 'forward';

        return (
            <div className={styles['graphic-container']}>
                <div className={styles.graphic}>
                    <div className={styles.contact}>
                        <div className={styles['icon-background']}>
                            {/* @ts-expect-error */}
                            <ContactsCircleIcon size='100%' fill='#fff' wrapWithDiv={false} />
                        </div>
                        <Title>Sara Diaz</Title>
                        <div className={styles.subtitle}>Person</div>
                    </div>
                    <GrowingDottedLine preventAnimation={!shouldAnimate} />
                    <div className={styles.entity}>
                        <motion.div
                            style={{opacity: 0}}
                            animate={{opacity: 1}}
                            transition={{delay: 1}}
                            initial={shouldAnimate && undefined}
                            className={styles.entity}
                        >
                            <div className={styles['icon-background']}>
                                {/* @ts-expect-error */}
                                <LeadsCircleIcon size='100%' fill='#fff' wrapWithDiv={false} />
                            </div>
                            <Title>Lead</Title>
                        </motion.div>
                        <motion.div
                            animate={{opacity: 0}}
                            style={{opacity: 1}}
                            initial={shouldAnimate && undefined}
                            className={styles['entity-title']}
                        >
                            <Title>ArrowGrid</Title>
                            <div className={styles.subtitle}>Company</div>
                        </motion.div>
                    </div>
                    <motion.div
                        style={{right: 5, top: 5}}
                        animate={{scale: 0.5, right: 282, top: -24}}
                        transition={spring}
                        initial={shouldAnimate && undefined}
                        className={styles['accounts-icon']}
                    >
                        {/* @ts-expect-error */}
                        <AccountsCircleIcon size='100%' fill='#fff' wrapWithDiv={false} />
                    </motion.div>
                </div>
            </div>
        );
    }
}
